import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { WarehouseService } from 'src/app/api/config/warehouse.service';
import { ToolsService } from 'src/app/utils/tools.service';
import * as moment from 'moment';
import SwalAlert from 'src/app/utils/swalalert';
declare var $: any;

@Component({
  selector: 'app-entry-form',
  templateUrl: './entry-form.component.html',
  styleUrls: ['./entry-form.component.css']
})
export class EntryFormComponent implements OnInit {
  private thisComponent: EntryFormComponent;
  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  // variables
  concepts: any = [];
  warehouses: any = [];
  products: any = [];

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private warehouseService: WarehouseService,
    private route: ActivatedRoute,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService,
    private alert: SwalAlert,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.thisComponent = this;
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.item = this.fb.group({
      warehouseconcept_id: [null, [Validators.required]],
      warehouse_id: [null, [Validators.required]],
      date_movement: [moment().format('YYYY-MM-DD'), [Validators.required]],
      reason: [null]
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {
    this.getWarehouses();
    this.getConcepts();
    this.navigationTrackerService.initializeMenu(this.route);
    (<any>$('[data-toggle="tooltip"]')).tooltip();
    setTimeout(() => {
      (<any>$('#date_movement')).attr('disabled', true);
    }, 50);
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  getWarehouses() {
    this.warehouseService.listWarehouseBranchoffice().subscribe({
      next: (data: any) => {
        this.warehouses = data.results;
        this.item.patchValue({
          warehouse_id: this.warehouses[0].id
        });
      }
    });
  }

  getConcepts() {
    this.warehouseService.listConceptEntry().subscribe({
      next: (data: any) => {
        this.concepts = data.results;
      }
    });
  }

  selectedProductSearch(item: any) {
    if (this.ifExistItem(item)) {
      item.quantity = null;
      item.price = null;
      item.date_expiration = null;
      item.subtotal = 0;
      item.unit_id = item.unitsmeasure[0].id;

      item.check_date_expiration = false;
      // if(item.is_control_expiration){
      //     item.check_date_expiration = true;
      // }
      this.products.push(item);
      let last = this.products.length;
      setTimeout(() => {
        (<any>$('#quantity' + (last - 1))).focus();
      }, 150);
    } else {
      this.alertifyMsg.warning(
        'El producto ' + item.description + ' ya se encuentra agregado'
      );
    }
  }

  ifExistItem(product: any) {
    let response = false;
    if (this.toolsService.notExistObjInArr(product, this.products)) {
      response = true;
    }
    return response;
  }

  changeDateExpiration(index: number) {
    if (!this.products[index].check_date_expiration) {
      this.products[index].check_date_expiration = true;
    } else {
      this.products[index].check_date_expiration = false;
    }
    // console.log(this.products[index].check_date_expiration);
    this.products[index].date_expiration = null;
    let component_ = this.thisComponent;
    if (this.products[index].check_date_expiration) {
      $('#expiration_date' + index).daterangepicker(
        {
          singleDatePicker: true,
          autoUpdateInput: false,
          showDropdowns: true,
          autoApply: true,
          locale: {
            format: 'YYYY-MM-DD'
          }
        },
        function(chosen_date: any) {
          // console.log(chosen_date.format('YYYY-MM-DD'));
          (<any>$('#expiration_date' + index)).val(
            chosen_date.format('YYYY-MM-DD')
          );
          component_.products[index].date_expiration = chosen_date.format(
            'YYYY-MM-DD'
          );
        }
      );
    }
  }

  changeQuantity(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.products[index].quantity = value_;
      this.changeSubtotal(index);
    }
  }

  changePrice(param: any, index: number): void {
    let value_ = param.value;
    if (!_.isNaN(value_ * 1)) {
      this.products[index].price = value_;
      this.changeSubtotal(index);
    }
  }

  changeUnitSelected(param: any, index: number, product: any): void {
    let value_ = param.value;
    let unitselected_ = this.toolsService.searchObjById(
      value_,
      product.unitsmeasure
    );
    this.products[index].unit_id = unitselected_.id;
    this.products[index].price = null;
    console.log('heree');
    console.log(unitselected_.id);
  }

  changeSubtotal(index: any) {
    let subtotal_ = this.products[index].price * this.products[index].quantity;
    this.products[index].subtotal = Number(subtotal_).toFixed(2);
  }

  removeProduct(index: any) {
    this.alertifyMsg.warning(
      'El producto ' +
        this.products[index].description +
        ' ha sido removido del detalle'
    );
    this.products.splice(index, 1);
  }

  preSave() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }
    if (this.validate()) {
      let options = {
        title: '¡Atención!',
        message: '¿Esta seguro(a) de registrar el ingreso de productos?',
        cancel: 'Cancelar',
        confirm: 'Sí, CONFIRMAR INGRESO !'
      };
      this.alert.confirmInfo(options).then((result: any) => {
        if (result.isConfirmed) {
          this.submitted = true;
          this.onSubmit();
        }
      });
    }
  }

  onSubmit() {
    let data: any = {};
    data.entry = this.item.value;
    data.detail = this.products;
    if (!this.isEdit) {
      this.warehouseService.saveEntry(data).subscribe({
        next: (data: any) => {
          this.alertifyMsg.success('Registro realizado con éxito');
          this.cancel();
        }
      });
    }
  }

  validate() {
    if (_.isNull(this.item.value.warehouseconcept_id)) {
      this.alertifyMsg.warning('Debe seleccionar un motivo.');
      return false;
    }

    if (this.products.length === 0) {
      this.alertifyMsg.warning(
        'Debe ingresar por lo menos un producto al detalle'
      );
      return false;
    } else {
      for (let i in this.products) {
        let product = this.products[i];
        if (Number(product.quantity) == 0 || _.isNull(product.quantity)) {
          this.alertifyMsg.warning(
            'La cantidad del producto ' +
              product.description +
              ' no puede ser igual a cero o estar vacío.'
          );
          (<any>$('#quantity' + i)).focus();
          return false;
        }

        if (Number(product.price) == 0 || _.isNull(product.price)) {
          this.alertifyMsg.warning(
            'El precio del producto ' +
              product.description +
              ' no puede ser igual a cero o estar vacío.'
          );
          (<any>$('#price' + i)).focus();
          return false;
        }
      }
    }

    return true;
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/almacen/entradas/lista']);
  }
}
